module.exports = __webpack_public_path__ + "static/media/icon-delete.dde0cc7b.svg";


//////////////////
// WEBPACK FOOTER
// ./src/static/img/xkCoach/icon-delete.svg
// module id = 1660
// module chunks = 0